export default "__VITE_ASSET__3663584d__"